import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Eye, EyeOff } from 'lucide-react';
import 'react-toastify/dist/ReactToastify.css';
import { useChangePassword } from '../../hooks/useUserProfile';
import styles from './MyAccount.module.css';


const ChangePasswordModal = ({ onClose }) => {
  const { changePassword, isLoading } = useChangePassword();
  
  const [passwords, setPasswords] = React.useState({
    newPassword: '',
    confirmPassword: ''
  });

  const [showPasswords, setShowPasswords] = React.useState({
    newPassword: false,
    confirmPassword: false
  });

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswords(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await changePassword(passwords);
      setPasswords({ newPassword: '', confirmPassword: '' });
      onClose();
    } catch (error) {
      // Error handling is managed by the hook
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>Change Password</h2>
        <form onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <div className={styles.passwordWrapper}>
              <input
                type={showPasswords.newPassword ? "text" : "password"}
                name="newPassword"
                placeholder="New Password"
                value={passwords.newPassword}
                onChange={handlePasswordChange}
                className={styles.input}
                disabled={isLoading}
              />
              <button
                type="button"
                className={styles.eyeButton}
                onClick={() => togglePasswordVisibility('newPassword')}
              >
                {showPasswords.newPassword ? 
                  <EyeOff size={20} /> : 
                  <Eye size={20} />
                }
              </button>
            </div>
          </div>
          <div className={styles.inputGroup}>
            <div className={styles.passwordWrapper}>
              <input
                type={showPasswords.confirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm New Password"
                value={passwords.confirmPassword}
                onChange={handlePasswordChange}
                className={styles.input}
                disabled={isLoading}
              />
              <button
                type="button"
                className={styles.eyeButton}
                onClick={() => togglePasswordVisibility('confirmPassword')}
              >
                {showPasswords.confirmPassword ? 
                  <EyeOff size={20} /> : 
                  <Eye size={20} />
                }
              </button>
            </div>
          </div>
          <div className={styles.modalButtons}>
            <button 
              type="submit" 
              className={styles.submitBtn}
              disabled={isLoading}
            >
              {isLoading ? 'Changing Password...' : 'Change Password'}
            </button>
            <button 
              type="button" 
              className={styles.cancelBtn}
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};
export default ChangePasswordModal